import React from 'react';
import {isMobile, isMacOs} from 'react-device-detect';
import styled from 'styled-components';
import {PopoverButton, TscButtonType, TscPopoverOrigin, Glyphs, TscThemeName, TscThemeNames} from '@techsmith/tsc-cloud-style-guide';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {disableConversationStore} from '../../context/disableConversationProvider';
import {useTranslation} from 'react-i18next';
import {PickerEmojiEvent} from '../../type/emoji-mart-data';

export const ShowEmojiButtonWrapper = styled.div<{$isEditing: boolean; $isTextOverflow: boolean}>`
   position: absolute;
   right: ${props =>
      isMacOs || isMobile ? '0.25rem' :
         props.$isTextOverflow ? '1rem' :
            props.$isEditing ? '0.25rem' : '0rem'};
   bottom: 0;

   button {
   transition: transform 0.2s ease;

      :hover {
         transform: translateY(-0.125rem);
      }
   }

   em-emoji-picker {
      margin-right: ${props =>
         isMacOs || isMobile ? '-0.375rem' :
            props.$isTextOverflow ? '-1.125rem' :
               props.$isEditing ? '-0.375rem' : '-0.125rem'};
   }
`;

export const EmojiPickerWrapperBase: React.FC<IEmojiPickerWrapperProps & IStateMappedProps> = ({isEditing, isTextOverflow, theme, onEmojiClick, isCommentingDisabled}) => {
   const {t} = useTranslation();
   const [picker, setPicker] = React.useState(<></>);
   const buttonTestId = 'emoji-picker-popover-btn';
   const emojiMartButtonSize = 27;
   const emojiMartEmojiSize = 20;

   return (
      <ShowEmojiButtonWrapper
         $isEditing={isEditing}
         $isTextOverflow={isTextOverflow}
         onClick={() => setPicker(
            <Picker
               data={data}
               emojiButtonSize={emojiMartButtonSize}
               emojiSize={emojiMartEmojiSize}
               searchPosition="none"
               theme={theme === TscThemeName.dawn ? 'light' : 'dark'}
               onEmojiSelect={(emoji: PickerEmojiEvent) => onEmojiClick(emoji)}
            />
         )}
      >
         <PopoverButton
            buttonType={TscButtonType.floating}
            origin={TscPopoverOrigin.bottomRight}
            width="2rem"
            buttonGlyph={<Glyphs.Emoji16x16 />}
            popoverMenu={picker}
            testId={buttonTestId}
            disabled={isCommentingDisabled}
            className="emoji-picker-popover"
            buttonTitle={t('conversations.emojiButtonTitle')}
         />
      </ShowEmojiButtonWrapper>
   );
};

export interface IEmojiPickerWrapperProps {
   isEditing: boolean;
   isTextOverflow: boolean;
   theme: TscThemeNames;
   onEmojiClick(emoji: PickerEmojiEvent): void;
}

export interface IStateMappedProps {
   isCommentingDisabled: boolean;
}

const mapStatesToProps = (
   {isEditing, isTextOverflow, theme, onEmojiClick}: IEmojiPickerWrapperProps,
   {isCommentingDisabled}: Partial<IStateMappedProps>
): IEmojiPickerWrapperProps & IStateMappedProps => ({isEditing, isTextOverflow, theme, onEmojiClick, isCommentingDisabled});

export default withMemoizedContexts(mapStatesToProps, disableConversationStore)(EmojiPickerWrapperBase);
